import { doNotEnterAdblock, rejectAdblock } from "api";

export const createAdBlockSlice = (set, get) => ({
    suggestionType: 'fasttext',
    suggestions: [],
    existingSuggestionID: null,
    setProductSuggestions: ({ type, suggestions, existingSuggestionID }) => {
        set({ suggestionType: type, suggestions: suggestions, existingSuggestionID: existingSuggestionID});
    },
    currentSuggestions: [],
    setCurrentSuggestions: (suggestions) => set({ currentSuggestions: suggestions }),
    events: [],
    addEvent: (event) => {
        const sanitizedEvent = event?.trim();
        if (!sanitizedEvent) {
            return;
        }
        set((state) => ({
            events: [...state.events.filter((item) => item?.trim()), sanitizedEvent],
        }));
    },
    productStartTime: null,
    initializeProductStartTime: () => set({ productStartTime: new Date().toISOString().replace(',','') }),
    offerStartTime: null,
    initializeOfferStartTime: () => set({ offerStartTime: new Date().toISOString().replace(',','') }),
    newitem_f: false,
    select_varieties_f: false,
    bulkqty_f: false,
    anomaly_f: false,
    split: false,
    sponsored_f: false,
    qr_code_f: false,
    coupon_f: false,
    couponDisabled: true,
    rebate_f: false,
    coupon_amnt: '',
    rebate_amnt: '',
    limitedtime_f: false,
    lt_start_dt: null,
    lt_end_dt: null,
    show_math_f: false,
    loyalty_f: false,
    meal_deal_f: false,
    online_only_f: false,
    sugar_tax_f: false,
    sold_out_f: false,
    brand_equity_f: false,
    // inc_discount_f: false,
    fsi_retailer_i: '',
    setMetaData: (data) => {
        set({
        newitem_f: data.newitem_f,
        select_varieties_f: data.select_varieties_f,
        bulkqty_f: data.bulkqty_f,
        anomaly_f: data.anomaly_f,
        split: data.split,
        sponsored_f: data.sponsored_f,
        qr_code_f: data.qr_code_f,
        coupon_f: data.coupon_f,
        rebate_f: data.rebate_f,
        coupon_amnt: data.coupon_amnt,
        rebate_amnt: data.rebate_amnt,
        limitedtime_f: data.limitedtime_f,
        lt_start_dt: data.lt_start_dt,
        lt_end_dt: data.lt_end_dt,
        show_math_f: data.show_math_f,
        loyalty_f: data.loyalty_f,
        meal_deal_f: data.meal_deal_f,
        online_only_f: data.online_only_f,
        sugar_tax_f: data.sugar_tax_f,
        brand_equity_f: data.brand_equity_f,
        // inc_discount_f: data.inc_discount_f,
        sold_out_f: data.sold_out_f,
        fsi_retailer_i: data.fsi_retailer_i || '',
        events: (data.events || []).filter((event) => event && event.trim()),
    })},
    updateMetaDataField: (field, value) => {
        set({ [field]: value });
    },
    resetMetaData: () => set({
        newitem_f: false,
        select_varieties_f: false,
        bulkqty_f: false,
        anomaly_f: false,
        split: false,
        sponsored_f: false,
        qr_code_f: false,
        coupon_f: false,
        rebate_f: false,
        coupon_amnt: '',
        rebate_amnt: '',
        limitedtime_f: false,
        lt_start_dt: null,
        lt_end_dt: null,
        show_math_f: false,
        loyalty_f: false,
        meal_deal_f: false,
        online_only_f: false,
        sugar_tax_f: false,
        brand_equity_f: false,
        // inc_discount_f: false,
        sold_out_f: false,
        fsi_retailer_i: '',
        events: [],
    }),
    getMetaData: () => {
        const state = get();
        return {
            newitem_f: state.newitem_f,
            select_varieties_f: state.select_varieties_f,
            bulkqty_f: state.bulkqty_f,
            anomaly_f: state.anomaly_f,
            split: state.split,
            sponsored_f: state.sponsored_f,
            qr_code_f: state.qr_code_f,
            coupon_f: state.coupon_f,
            rebate_f: state.rebate_f,
            coupon_amnt: state.coupon_amnt ? state.coupon_amnt : null,
            rebate_amnt: state.rebate_amnt ? state.rebate_amnt : null,
            limitedtime_f: state.limitedtime_f,
            lt_start_dt: state.lt_start_dt,
            lt_end_dt: state.lt_end_dt,
            show_math_f: state.show_math_f,
            loyalty_f: state.loyalty_f,
            meal_deal_f: state.meal_deal_f,
            online_only_f: state.online_only_f,
            sugar_tax_f: state.sugar_tax_f,
            brand_equity_f: state.brand_equity_f,
            // inc_discount_f: state.inc_discount_f,
            sold_out_f: state.sold_out_f,
            fsi_retailer_i: state.fsi_retailer_i,
            event_nm: state.events.filter((event) => event && event.trim()).join(","),
        };
    },
    isImported: false,
    setIsImported: (flag) => set({ isImported: flag }),
    do_not_enter_f: false,
    rejected_f: false,
    dneBlock: async () => {
        set({ isDNELoading: true });
        let result = await doNotEnterAdblock(get().currentAdBlockID, {}, "edit");
        if (result.success) {
            get().setAdblockList(get().currentPageID);
            get().navigateNextUnapproved();
            return true;
        }
        set({ isDNELoading: false });
        return false;
    },
    rejectBlock: async (remove_children = false) => {
        set({ isRejecting: true });
        let result = await rejectAdblock(get().currentAdBlockID, "edit", "", remove_children);
        if (result.success) {
            get().setAdblockList(get().currentPageID);
            get().navigateNextUnapproved();
        }
        set({ isRejecting: false });
    }
})
